(function() {
  'use strict';

  angular
    .module('blocks.asyncTasks', []);
})();
